module.exports = __webpack_public_path__ + "static/img/8.0f41463.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresas/8.png
// module id = +Y0Y
// module chunks = 0